import React from 'react';
import { MessageCircle } from 'lucide-react'; // Agar aap lucide-react use kar rahe hain

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/18035409934?text=Hello%20Zygma%20Growth%20Solutions,%20I%20need%20your%20help!"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-10 right-10 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 flex items-center justify-center"
      style={{ boxShadow: '0px 4px 15px rgba(0,0,0,0.2)' }}
    >
      <MessageCircle size={30} />
    </a>
  );
};

export default WhatsAppFloat;